/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityAnswer } from '../../models/security-answer';

export interface SecurityAnswersGet$Params {
  questionIds?: Array<string> | null;
}

export function securityAnswersGet(http: HttpClient, rootUrl: string, params?: SecurityAnswersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityAnswer>>> {
  const rb = new RequestBuilder(rootUrl, securityAnswersGet.PATH, 'get');
  if (params) {
    rb.query('questionIds', params.questionIds, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SecurityAnswer>>;
    })
  );
}

securityAnswersGet.PATH = '/api/SecurityAnswers';
